import { IsString, Matches, MinLength } from 'class-validator';

import { browserIdRegexp } from '@onArte/shared/regexp';

export class FacebookContextModel {
  @IsString()
  @MinLength(1)
  public eventId: string;

  @IsString()
  @MinLength(1)
  public userAgent: string;

  @IsString()
  @MinLength(1)
  @Matches(browserIdRegexp)
  public browserId: string;
}
